module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAaUlEQVRYR+2WwQ0AIRACobO7ys6rfE2M8WEBsA98+AVnwSxhPjTrIwZ6EKiqD8BQ5oHkevy6YmATeMQjeM8IlMK3Vo8WhICdgL0F+YjsBOwhjIEQ2C2QgiD5ZyNqR8CXAanyJZaVzE5gAjKINCHILCnbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/opendrawer.png
// module id = dYQV
// module chunks = 18